<template>
  <card-modal :visible="true" :title="title" :showPreview="false" :okText="'Confirmar'" :disableOk="false">
    <div id="modal-edit-content" class="content">
      <span class="icon is-large modal-center-icon">
        <i class="fa fa-exclamation-triangle"></i>
      </span>
      <div class="has-text-centered">
        Ao remover Sub-slides todo o seu <b>conteúdo associado</b> será também <b>removido</b>.
        <br/>Isto inclui <b>Características e todos os Sub-slides</b>.
      </div>
    </div>
  </card-modal>
</template>

<script>
import CardModal from '../Util/CardModal'

export default {
  components: {
    CardModal
  },

  props: {
    title: String,
    coach_id: Number,
    menu_id: Number,
    id: Number
  },

  data () {
    return {
      showPreview: false
    }
  },

  computed: {
    currentEvent () {
      return window.store.state.event.nextEvent
    },

    submitIsActive () {
      return true
    },

    previewIsActive () {
      return false
    }
  },

  methods: {
  },

  watch: {
    currentEvent: function (val) {
      if (val === 'modal-card-close') {
        this.$destroy()
      }
      if (val === 'modal-card-ok') {
        let data = {
          coach: this.coach_id,
          menu: this.menu_id,
          id: this.id
        }
        window.store.dispatch('deleteSubMenu', data)
      }
      if (val === 'modal-card-preview') {
        // no preview
      }
      if (val === 'modal-card-cancel') {
        window.store.dispatch('newEvent', 'modal-card-close')
      }
    },

    submitIsActive: function (val) {
      if (val) {
        document.querySelector('.card-modal-ok-btn').classList.remove('is-disabled')
      } else {
        document.querySelector('.card-modal-ok-btn').classList.add('is-disabled')
      }
    },

    previewIsActive: function (val) {
      if (val) {
        document.querySelector('.card-modal-preview-btn').classList.remove('is-disabled')
      } else {
        document.querySelector('.card-modal-preview-btn').classList.add('is-disabled')
      }
    }
  }
}
</script>

<style>
  .modal-center-icon {
    width: 100% !important;
  }
</style>


// WEBPACK FOOTER //
// SlideSetDeleteModal.vue?33037b6f